import React from 'react';
import { withRouter } from "react-router-dom";
import OrderMonitor from './OrderMonitor.Component';



const OrderMonitorLanding = () => {
    return <OrderMonitor/>
}
export default withRouter(OrderMonitorLanding);